import ActionConditionsCardView from './ActionConditionsCardView.html';
import '../../Actions.scss';
import './ActionConditionsCard.scss';
class ActionConditionsCard {
    constructor() { }
}
export const ActionConditionsCardComponent = {
    controller: ActionConditionsCard,
    controllerAs: '$ctrl',
    template: ActionConditionsCardView,
    bindings: {
        action: '=',
        state: '=',
        application: '<',
        save: '&',
        createCondition: '&',
        removeCondition: '=',
    },
};
